<h2 mat-dialog-title>
    Contact Details
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
</h2>

<div *ngIf="showProgress">
    <mat-progress-bar class="example-margin" mode="indeterminate">
    </mat-progress-bar>
</div>

<mat-dialog-content>
    <ng-container *ngIf="referralContacts.length > 0">
        <table mat-table [dataSource]="referralContacts" class="mat-elevation-z8">

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="toggleSelectAll($event)"
                                  [checked]="isAllSelected()"
                                  [indeterminate]="isSomeSelected() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox (change)="toggleSelection(element)" [checked]="isSelected(element)"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="contactId">
                <th mat-header-cell *matHeaderCellDef style="font-weight:700;"> Contact ID </th>
                <td mat-cell *matCellDef="let element"> {{element.contactId}} </td>
            </ng-container>

            <ng-container matColumnDef="contactName">
                <th mat-header-cell *matHeaderCellDef style="font-weight:700;"> Contact Name </th>
                <td mat-cell *matCellDef="let element"> {{element.contactName}} </td>
            </ng-container>

            <ng-container matColumnDef="jurisdiction">
                <th mat-header-cell *matHeaderCellDef style="font-weight:700;"> Jurisdiction </th>
                <td mat-cell *matCellDef="let element"> {{element.jurisdictionCode}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef style="font-weight:700;"> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </ng-container>
    <ng-container *ngIf="!(referralContacts.length > 0) && !showProgress">
        <div class="no-data-found"><span>No Referred Contacts Found</span></div>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button
            type="submit"
            [disabled]="!(this.selectedItems.length>0)"
            (click)="upload()"
            [class]="!(this.selectedItems.length>0) ? 'btn-disabled' : 'btn-upload'">
        Upload PDF
    </button>

    <button mat-raised-button type="submit" *ngIf="this.selectedItems.length == 1 && downloadPdfBtn" class="btn-upload" (click)="downloadPdf()">Download PDF</button>
</mat-dialog-actions>
